import { LayoutMode } from "views/Account/ConfigManagement/types";

export const LAYOUT_MODE_LOCAL_STORAGE_KEY = "run-tasks-layout-mode";
export const DEFAULT_LAYOUT_MODE = LayoutMode.Diagram;
export const FILTERS_ORDER_SETTINGS_KEY = "searchRunHosts";
